// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"658e7bab","239":"48ee0f42","389":"0df3f786","450":"d0c0265e","453":"0a3d5895","692":"144f40e5","732":"815d3357","857":"734f4e5f","867":"ee48125d","977":"5b85c0c8"}[chunkId] + ".chunk.js";
};